import LanguageStore from '@store/Language.store';
import { useStore } from '@ui/hooks/useStore';

const useDictionary = () => {
    const { lang: langStore } = useStore();
    const getWord: LanguageStore['getWord'] = langStore.getWord.bind(langStore);
    return getWord;
};

export default useDictionary;
